import { PriceListProductPropertyItem } from "./price-list-product-property-item.model";

export class PriceListProductProperty {
  id: number;
  idProductProperty: number;
  enabled: boolean;
  productPropertyItems: PriceListProductPropertyItem[];
}
